import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, type Lang } from "../lib/lang";

export function LangToggle() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language?.slice(0, 2) ?? "en") as Lang;

  function set(lang: Lang) {
    if (lang !== current) i18n.changeLanguage(lang);
  }

  return (
    <div className="acx__lang-toggle" role="group" aria-label={t("nav.languageGroupLabel")}>
      {SUPPORTED_LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          className={`acx__lang-toggle-btn${lang === current ? " acx__lang-toggle-btn--active" : ""}`}
          onClick={() => set(lang)}
          aria-pressed={lang === current}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
